
















































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import MessageMixin from './Message';

@Component
export default class MessageText extends Mixins(MessageMixin) {
  @Prop() readonly isHovered!: boolean;
  @Prop() readonly isFirstMsg!: boolean;
  @Prop({type: Number, default: null}) readonly lastPatientReadMessageId!: number | null;
  messageContent: string = '';
  isMenuOpen: boolean = false;

  mounted() {
    try {
      const messageParse = JSON.parse(this.message.message_content);
      this.messageContent = messageParse.doctor || this.message.message_content;
    } catch (e) {
      this.messageContent = this.message.message_content;
    }

    document.addEventListener('click', this.handleClickOutside);
  }

  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  handleClickOutside(e: MouseEvent) {
    const menu = this.$refs.actionMenu as HTMLElement;
    if (menu && !menu.contains(e.target as Node)) {
      this.isMenuOpen = false;
    }
  }

  handleHideMenuAction() {
    this.$emit('hover', null);
    this.isMenuOpen = false;
  }
}
